module.exports = __webpack_public_path__ + "img/text-classify12.be0a73bf.png";